const Generic = require("../GenericThemeFunctions")

module.exports = {
    scssVariables: './src/styles/raffo2024',
    defaultLanguage: 'es',
    randomNickname:  () => { return Generic.RandomNickname() },
    favicon: 'raffofavicon.ico',
    defaultPassword: 'desafionolter'
}